import {
  InputRequirement,
  InputRequirementSchema,
} from "@intelligems/ig-types/schemas/ai/nodes/input-requirement";
import { ToolResultOutputSchema } from "@intelligems/ig-types/schemas/ai/nodes/tool-execution-result";

export const readRequestUserInputOutput = (
  output: unknown
): InputRequirement | undefined => {
  const parsedOutput = ToolResultOutputSchema.safeParse(output);
  if (!parsedOutput.success || parsedOutput.data.type !== "json") {
    return undefined;
  }

  const parsedRequirement = InputRequirementSchema.safeParse(
    parsedOutput.data.value.results
  );
  if (
    !parsedRequirement.success ||
    typeof parsedRequirement.data.prompt !== "string"
  ) {
    return undefined;
  }

  return parsedRequirement.data;
};
